export const injectHeaderAndFooter = (prompt: string, header: string, footer: string, midpoint?: string) => {
    let result = prompt.replace('<header>', header).replace('<footer>', footer);
    if (midpoint) {
        result = result.replace('<midpoint>', midpoint);
    }
    return result;
}

/**
 * Get the current date formatted for AI context
 */
export const getCurrentDateString = (): string => {
    const now = new Date();
    return now.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

/**
 * Returns context around a JSON error position (20 characters before and after)
 * @param errorString - The error message containing position information (e.g., "at position 793 (line 17 column 125)")
 * @param jsonString - The JSON string that was attempted to be parsed
 * @returns A string with context around the error position, or null if unable to determine
 */
export const getJsonErrorContext = (errorString: string, jsonString: string): string | null => {
    try {
        // Extract position from error string using regex
        const positionMatch = errorString.match(/at position (\d+)/);
        if (!positionMatch) {
            return null;
        }
        
        const errorPosition = parseInt(positionMatch[1], 10);
        
        // If position is beyond the string length, return null
        if (errorPosition >= jsonString.length) {
            return null;
        }
        
        // Calculate start and end positions for context
        const startPos = Math.max(0, errorPosition - 40);
        const endPos = Math.min(jsonString.length, errorPosition + 40);
        
        // Extract context and add position indicator
        const beforeContext = jsonString.substring(startPos, errorPosition);
        const afterContext = jsonString.substring(errorPosition, endPos);
        
        return `Aproximate error position: ${beforeContext}<<<ERROR HERE>>>${afterContext}`;
    } catch (error) {
        // If any error occurs during parsing, return null
        return null;
    }
};